import variables from "@/utils/variables";

export default function formatPropertyType(v) {
  for (let t of variables.propertyType) {
    if (v == t.value) {
      return t.text;
    }
  }

  return "-";
}
